import { Helmet } from "react-helmet-async";

const DEFAULT_IMAGE = "https://images.pexels.com/photos/18419510/pexels-photo-18419510.jpeg";
const SITE_URL = "https://creative-ai-hub-344.preview.emergentagent.com";
const SITE_NAME = "VisionAI Studio";

export default function SEO({
  title = "VisionAI Studio — Générez des vidéos IA en quelques secondes",
  description = "Transformez vos idées en vidéos IA cinématographiques à partir de texte ou d'images. 3 crédits offerts à l'inscription. Génération HD ultra-rapide.",
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  jsonLd = null,
}) {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} · ${SITE_NAME}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="theme-color" content="#050505" />
      <link rel="canonical" href={url} />
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {/* JSON-LD */}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}

export const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/logo192.png`,
  sameAs: [],
};

export const siteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: SITE_NAME,
  url: SITE_URL,
};

export const softwareJsonLd = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: SITE_NAME,
  applicationCategory: "MultimediaApplication",
  operatingSystem: "Web",
  description: "AI video generation platform: transform text or images into cinematic videos in seconds.",
  offers: [
    { "@type": "Offer", name: "Gratuit", price: "0", priceCurrency: "USD" },
    { "@type": "Offer", name: "Mensuel", price: "7", priceCurrency: "USD" },
    { "@type": "Offer", name: "Annuel", price: "200", priceCurrency: "USD" },
  ],
};
